import { useAppSelector } from "../../../../redux/hooks";
import { MemberDashboard } from "./member";

export const Dashboard = () => {
  const { profile } = useAppSelector((state) => state.auth);
  return profile?.type === "cooperative" ? <>Coop dash</> : <MemberDashboard />;
};
